"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const ClusterList_1 = __importDefault(require("@becrop/components/Toolkit/Common/models/ClusterList"));
const ClusterEditorParcel_vue_1 = __importDefault(require("./ClusterEditorParcel.vue"));
const ClusterEditorCluster_vue_1 = __importDefault(require("./ClusterEditorCluster.vue"));
const SavedCluster_1 = require("@becrop/components/Toolkit/Common/models/SavedCluster");
const lucide_vue_next_1 = require("lucide-vue-next");
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const UIRadio2_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/UIRadio2.vue"));
const ClusterEditorSave_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/ClusterEditorSave.vue"));
const ClusterEditorSavedList_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/ClusterEditorSavedList.vue"));
let ClusterEditor = class ClusterEditor extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.clusters = new ClusterList_1.default(this.numClusters);
        this.filteredParcels = this.parcels;
        this.allSamples = this.parcels.map(p => p.samples);
        this.search = '';
        this.focusMode = 'code';
        this.displayOptions = [
            {
                value: 'code',
                label: (0, trans_1.trans)('heatmap.general.code')
            },
            {
                value: 'name',
                label: (0, trans_1.trans)('heatmap.general.name')
            }
        ];
        //
        // List of clusters
        //
        this.saved_cluster_list = new SavedCluster_1.SavedClusterList();
    }
    clearSearch() {
        this.search = '';
    }
    hideClusters() {
    }
    onChangeSearch() {
        const allParcels = this.parcels.map(p => p);
        this.filteredParcels = allParcels.map(p => p).filter((parcel, i) => {
            if (parcel.name.toLowerCase().includes(this.search.toLowerCase()))
                return parcel;
            else {
                if (parcel.samples.some(s => s.id.toString().toLowerCase().includes(this.search.toLowerCase())) ||
                    parcel.samples.some(s => s.code.toString().toLowerCase().includes(this.search.toLowerCase())) ||
                    parcel.samples.some(s => s.name.toString().toLowerCase().includes(this.search.toLowerCase())) ||
                    parcel.samples.some(s => s.date.toString().toLowerCase().includes(this.search.toLowerCase()))) {
                    parcel.samples = this.allSamples[i];
                    parcel.samples = parcel.samples.filter(s => s.id.toString().toLowerCase().includes(this.search.toLowerCase()) ||
                        s.code.toString().toLowerCase().includes(this.search.toLowerCase()) ||
                        s.name.toString().toLowerCase().includes(this.search.toLowerCase()) ||
                        s.date.toString().toLowerCase().includes(this.search.toLowerCase()));
                    return parcel;
                }
            }
        });
    }
    mounted() {
        if (this.previous) {
            this.clusters = this.previous;
        }
    }
    onCreate() {
        if (!this.clusters.ready)
            return;
        this.$emit('clusters', this.clusters);
    }
    loadSavedCluster(savedCluster) {
        this.clusters = savedCluster.build();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditor.prototype, "parcels", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 3 })
], ClusterEditor.prototype, "numClusters", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], ClusterEditor.prototype, "previous", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], ClusterEditor.prototype, "withIcon", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: () => { return (sample) => false; } })
], ClusterEditor.prototype, "sampleDisabledFn", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('search')
], ClusterEditor.prototype, "onChangeSearch", null);
ClusterEditor = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ClusterEditorSavedList: ClusterEditorSavedList_vue_1.default,
            ClusterEditorSave: ClusterEditorSave_vue_1.default,
            CusterEditorParcel: ClusterEditorParcel_vue_1.default,
            ClusterEditorCluster: ClusterEditorCluster_vue_1.default,
            Loader: Loader_vue_1.default,
            UIRadio: UIRadio2_vue_1.default,
            Save: lucide_vue_next_1.Save,
            ArrowRight: lucide_vue_next_1.ArrowRight
        }
    })
], ClusterEditor);
exports.default = ClusterEditor;
